/* ══════════ Onboarding-Tour (einmalig beim ersten Start) ══════════ */
export const TOUR_STEPS = [
  { sel: null, title: 'Willkommen bei mimorio! 🐱', text: 'Deine gemütliche Karteikarten-Ecke. In 20 Sekunden zeig ich dir das Wichtigste.' },
  { sel: '[data-view="dashboard"]', title: 'Lernen starten', text: 'Auf der Startseite wählst du, wie viele Karten du übst – und legst los. mimorio plant automatisch, welche Karten heute dran sind.' },
  { sel: '.v2-cardmgr', title: 'Karten anlegen', text: 'Direkt auf der Übersicht: neue Karten anlegen (mit Bildern, Formeln $…$, Code, Lückentext), importieren (Anki/Quizlet/CSV) oder alle verwalten.' },
  { sel: '[data-view="adventure"]', title: 'Wissensabenteuer ⚔️', text: 'Jede gelernte Karte hilft Mimorio gegen den Vergessensnebel – sammle Münzen, Schatztruhen und Lernbegleiter!' },
  { sel: '[data-view="community"]', title: 'Community & Freunde', text: 'Veröffentliche Decks, finde Freund:innen, starte Lern-Duelle, tritt Uni-Communitys bei und sieh den Feed.' },
  { sel: '#buddy-box', title: 'Deine Katze 🏆', text: 'Sammle XP, Münzen & Diamanten und schalte Erfolge frei. Viel Spaß beim Lernen!' },
];
export function startTour(force) {
  if (!force && localStorage.getItem('tourDone')) return;
  let i = 0;
  const ov = document.createElement('div');
  ov.className = 'tour-ov';
  ov.innerHTML = `<div class="tour-spot"></div>
    <div class="tour-pop">
      <div class="tour-step"></div>
      <h4 class="tour-title"></h4>
      <p class="tour-text"></p>
      <div class="tour-actions">
        <button class="tour-skip">Überspringen</button>
        <button class="tour-next btn-primary tiny"></button>
      </div>
    </div>`;
  document.body.appendChild(ov);
  const spot = ov.querySelector('.tour-spot');
  const pop = ov.querySelector('.tour-pop');
  const done = () => { localStorage.setItem('tourDone', '1'); ov.remove(); };
  ov.querySelector('.tour-skip').onclick = done;
  const render = () => {
    const s = TOUR_STEPS[i];
    ov.querySelector('.tour-step').textContent = `${i + 1} / ${TOUR_STEPS.length}`;
    ov.querySelector('.tour-title').textContent = s.title;
    ov.querySelector('.tour-text').textContent = s.text;
    ov.querySelector('.tour-next').textContent = i === TOUR_STEPS.length - 1 ? 'Los geht’s!' : 'Weiter';
    const el = s.sel && document.querySelector(s.sel);
    const r = el && el.getBoundingClientRect();
    if (r && r.width && r.height) {
      const pad = 8;
      spot.style.opacity = '1';
      spot.style.left = (r.left - pad) + 'px'; spot.style.top = (r.top - pad) + 'px';
      spot.style.width = (r.width + pad * 2) + 'px'; spot.style.height = (r.height + pad * 2) + 'px';
      // Pop unter oder über dem Element platzieren
      const below = r.bottom + 180 < window.innerHeight;
      pop.style.left = Math.max(12, Math.min(window.innerWidth - 332, r.left)) + 'px';
      pop.style.top = (below ? r.bottom + 14 : Math.max(12, r.top - 172)) + 'px';
      pop.style.transform = 'none';
    } else {
      spot.style.opacity = '0';
      pop.style.left = '50%'; pop.style.top = '50%'; pop.style.transform = 'translate(-50%,-50%)';
    }
  };
  ov.querySelector('.tour-next').onclick = () => { i++; if (i >= TOUR_STEPS.length) return done(); render(); };
  window.addEventListener('resize', render);
  render();
}

